export const PAGE_TITLES = [
  { path: "/", title: "Home" },

  // API
  { path: "/api", title: "API" },

  // Cohorts
  { path: "/cohort", title: "Cohort" },
  { path: "/cohort/:cohort_id", title: "Cohort #{cohort_id}" },
  { path: "/cohorts", title: "Cohorts List" },
  { path: "/cohorts/workload/leaders", title: "Cohorts Workload - Leaders" },
  { path: "/cohorts/workload/program-managers", title: "Cohorts Workload - Program Managers" },

  // Demo Records
  { path: "/demo/records", title: "Demo Records" },

  // Diplomas
  { path: "/diplomas", title: "Diplomas" },
  { path: "/diplomas/import", title: "Import Diplomas" },

  // Evaluations
  { path: "/evaluations", title: "Evaluations" },
  { path: "/evaluation-attempt/:eval_id", title: "Correction - #{eval_id}" },
  { path: "/evaluations/attempts", title: "Evaluation Attempts" },

  // Insights
  { path: "/insights", title: "Insights" },
  { path: "/insights/evaluation-accuracy", title: "Evaluation Accuracy" },
  { path: "/insights/surveys", title: "Surveys" },

  // Invitations
  { path: "/invitations", title: "Invitations" },
  { path: "/courses", title: "Courses" },

  // Login
  { path: "/login", title: "Login" },

  // Meetings
  { path: "/meeting/:meeting_id", title: "Meeting - {meeting_id}" },
  { path: "/meetings", title: "Meetings" },
  { path: "/meetings/latest", title: "Latest Meetings" },
  { path: "/meetings/import", title: "Import Meetings" },
  { path: "/meetings/types", title: "Meeting Types" },
  { path: "/meetings/absence-proofs", title: "Absence Proofs" },
  { path: "/meetings/workload", title: "Meetings Workload" },
  {
    path: "/meetings/:meeting_id/absence-proofs/:user_id",
    title: "Absence Proof - Meeting {meeting_id} - User #{user_id}",
  },

  // Messages
  { path: "/messages", title: "Messages" },

  // Modules
  { path: "/modules/users/import", title: "Import modules for users" },

  // Permissions
  { path: "/permissions", title: "Permissions" },
  { path: "/permissions/api-keys", title: "API Keys" },
  { path: "/permissions/staff-members", title: "Staff Members" },
  { path: "/permissions/user-roles-scopes", title: "User Roles Scopes" },
  { path: "/permissions/import", title: "Import Permissions" },

  // Projects
  { path: "/projects", title: "Projects" },
  { path: "/projects/subjects", title: "Project Subjects" },
  { path: "/projects/workload", title: "Projects Workload" },
  // Programs
  { path: "/programs", title: "Programs" },
  { path: "/program/:program_id", title: "Program #{program_id}" },

  // Ephemeral
  { path: "/ephemeral/sessions", title: "Ephemeral Sessions" },
  { path: "/ephemeral/exercises", title: "Ephemeral Exercises" },
  { path: "/ephemeral/import", title: "Import Ephemeral Exercises" },
  { path: "/ephemeral/users", title: "Ephemeral Users" },

  // Settings
  { path: "/settings", title: "Settings" },

  // Users
  { path: "/user/:user_id", title: "User #{user_id}" },
  { path: "/users", title: "Users List" },
];

const _matchPath = (pattern: string, pathname: string) => {
  const patternParts = pattern.split("/");
  const pathParts = pathname.split("/");
  if (patternParts.length !== pathParts.length) return null;

  const params: { [key: string]: string } = {};
  let isMatch = true;
  patternParts.forEach((part: string, index: number) => {
    if (part.startsWith(":")) {
      const key = part.substring(1);
      params[key] = pathParts[index];
    } else if (part !== pathParts[index]) {
      isMatch = false;
    }
  });
  return isMatch ? params : null;
};

export const getTitleForPath = (pathname: string): string => {
  const exact = PAGE_TITLES.find((page) => page.path === pathname);
  if (exact) return exact.title;

  for (const route of PAGE_TITLES) {
    if (route.path.includes(":")) {
      const params = _matchPath(route.path, pathname);
      if (params) {
        let title = route.title;

        Object.entries(params).forEach(([key, value]) => {
          title = title.replace(`{${key}}`, String(value));
        });
        return title;
      }
    }
  }

  return "Nexus";
};
